"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var _react = _interopRequireDefault(require("react"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./ToggleButton.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * ToggleButton allow users to select between two options
 *
 * When a `ref` prop is provided, it will be forwarded to the root element.
 * Any other properties supplied will be provided to the root element. This
 * includes all appropriate HTML attributes or aria tags.
 */
const ToggleButton = /*#__PURE__*/_react.default.forwardRef(({
  variant = 'primary',
  selectedTab = 1,
  onToggle,
  disabled,
  values,
  className,
  ...otherProps
}, ref) => {
  const [tab1, tab2] = values;
  const isFirstTabSelected = selectedTab === 1;

  const handleToggle = () => onToggle(selectedTab === 1 ? 2 : 1);

  return (0, _pragma.createFelaElement)("div", {
    css: css.container,
    cssProps: {
      disabled
    },
    className: className
  }, (0, _pragma.createFelaElement)("input", _extends({
    css: css.input,
    type: "checkbox",
    checked: isFirstTabSelected,
    onChange: handleToggle,
    disabled: disabled,
    ref: ref
  }, otherProps)), (0, _pragma.createFelaElement)("div", {
    cssProps: {
      selectedTab,
      disabled,
      variant
    },
    css: css.button
  }), (0, _pragma.createFelaElement)(_.Text, {
    cssProps: {
      selectedTab,
      disabled,
      variant,
      isSelected: isFirstTabSelected
    },
    css: css.text,
    size: "m",
    weight: "bold",
    color: "text.3"
  }, tab1), (0, _pragma.createFelaElement)(_.Text, {
    cssProps: {
      selectedTab,
      disabled,
      variant,
      isSelected: !isFirstTabSelected
    },
    css: css.text,
    size: "m",
    weight: "bold",
    color: "text.3"
  }, tab2));
});

ToggleButton.displayName = 'ToggleButton';
var _default = ToggleButton;
exports.default = _default;
//# sourceMappingURL=ToggleButton.js.map